import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb43d8ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "log-dialog" }
const _hoisted_2 = { class: "archive-version" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "归档版本", -1))
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "info-card" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "公司", -1))
const _hoisted_8 = { class: "info-value" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "渠道", -1))
const _hoisted_11 = { class: "info-value" }
const _hoisted_12 = { class: "info-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "客户编码", -1))
const _hoisted_14 = { class: "info-value" }
const _hoisted_15 = { class: "info-item info-item-name" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "客户名称", -1))
const _hoisted_17 = ["title"]
const _hoisted_18 = {
  key: 0,
  class: "log-empty"
}
const _hoisted_19 = {
  key: 1,
  class: "log-timeline"
}
const _hoisted_20 = { class: "log-axis" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-dot" }, null, -1))
const _hoisted_22 = {
  key: 0,
  class: "log-line"
}
const _hoisted_23 = { class: "log-content" }
const _hoisted_24 = { class: "log-time" }
const _hoisted_25 = { class: "log-card" }
const _hoisted_26 = { class: "log-row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "风险等级：", -1))
const _hoisted_28 = { class: "log-value" }
const _hoisted_29 = { class: "log-row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "风险等级原因：", -1))
const _hoisted_31 = { class: "log-value" }
const _hoisted_32 = { class: "log-row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "逾期原因及说明：", -1))
const _hoisted_34 = { class: "log-value" }
const _hoisted_35 = { class: "log-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "是否起诉客户：", -1))
const _hoisted_37 = { class: "log-value" }
const _hoisted_38 = { class: "log-footer" }

import { ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import type { HistoryRiskRecordLogItem, ReceivableHistoryItem } from './index';
import { queryHistoryRiskRecordLog } from './index';


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewHistoryRiskLogDialog',
  props: {
    visible: { type: Boolean },
    record: null
  },
  emits: ["update:visible"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean;
  record: ReceivableHistoryItem | null;
}





const loading = ref(false);
const logs = ref<HistoryRiskRecordLogItem[]>([]);

function formatIsProsecute(value?: number | string | boolean) {
  if (value === 1 || value === '1' || value === true || value === 'true' || value === '是') {
    return '是';
  }
  if (value === 0 || value === '0' || value === false || value === 'false' || value === '否') {
    return '否';
  }
  return '-';
}

watch(
  () => props.visible,
  async (open) => {
    if (!open) {
      logs.value = [];
      return;
    }
    await fetchLogs();
  },
);

async function fetchLogs() {
  const historyCode = (props.record?.historyCode || '').trim();
  const sapCustomerCode = (props.record?.customerCode || '').trim();
  const dissaleChannelCode = (props.record?.dissaleChannelCode || '').trim();
  if (!historyCode || !sapCustomerCode || !dissaleChannelCode) {
    message.error('缺少归档版本、客户编码或渠道信息，无法查询日志');
    logs.value = [];
    return;
  }

  loading.value = true;
  try {
    logs.value = await queryHistoryRiskRecordLog({
      historyCode,
      dissaleChannelCode,
      sapCustomerCode,
      corpCode: (props.record?.corpCode || '').trim(),
    });
  } catch (error) {
    logs.value = [];
    message.error(error instanceof Error ? error.message : '查询修改日志失败');
  } finally {
    loading.value = false;
  }
}

function handleCancel() {
  emit('update:visible', false);
}

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: __props.visible,
    title: "风险修改记录",
    width: 640,
    "mask-closable": false,
    "destroy-on-close": "",
    onCancel: handleCancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_component_a_button, { onClick: handleCancel }, {
          default: _withCtx(() => [
            _createTextVNode("关闭")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", {
            class: "info-value",
            title: __props.record?.historyName || __props.record?.historyCode || '-'
          }, _toDisplayString(__props.record?.historyName || __props.record?.historyCode || '-'), 9, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(__props.record?.corpCode || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(__props.record?.channel || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(__props.record?.customerCode || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", {
              class: "info-value",
              title: __props.record?.customerName || '-'
            }, _toDisplayString(__props.record?.customerName || '-'), 9, _hoisted_17)
          ])
        ]),
        _createVNode(_component_a_spin, { spinning: loading.value }, {
          default: _withCtx(() => [
            (!loading.value && !logs.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, "暂无修改日志"))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logs.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "log-item"
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        (index < logs.value.length - 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createTextVNode(_toDisplayString(item.createDate || '-') + " ", 1),
                          (item.createName || item.createWorkCode)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" | " + _toDisplayString(item.createName || '-') + " ", 1),
                                (item.createWorkCode)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("(" + _toDisplayString(item.createWorkCode) + ")", 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("span", _hoisted_28, _toDisplayString(item.riskLevel || '-'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _hoisted_30,
                            _createElementVNode("span", _hoisted_31, _toDisplayString(item.riskReason || '-'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("span", _hoisted_34, _toDisplayString(item.riskDesc || '-'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _createElementVNode("span", _hoisted_37, _toDisplayString(formatIsProsecute(item.isProsecute)), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
          ]),
          _: 1
        }, 8, ["spinning"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})